import { SCHEMA_IDS, SITE_ORIGIN } from '../constants';

export const FAQ_SECTIONS = [
  {
    id: 'ordering',
    title: 'Ordering',
    items: [
      {
        q: 'What is Barista Bot?',
        a: 'Barista Bot is a text-based ordering system for coffee shops. Customers order and pay by text — no app to download. It is a product of Espresso + Milk, LLC.',
      },
      {
        q: 'How do I place an order?',
        a: 'Text the shop’s Barista Bot number like you would text a friend. Say what you want, confirm the total, and reply yes to charge the card on file. The ticket shows up for the barista like a mobile Order Ahead order.',
      },
      {
        q: 'Do I need an app?',
        a: 'No. Open Messages and text the shop. Your Barista Bot account keeps your card, order history, and store preference so the next order is faster.',
      },
      {
        q: 'What are emoji shortcuts?',
        a: 'Add an emoji to a favorite order and Barista Bot saves it. Next time, send that emoji to fast-track the same drink, customizations, and quantity in one text.',
      },
      {
        q: 'How do I pay?',
        a: 'On Square, payment rides the Order Ahead rails. Without a POS, Stripe charges the card on file. You confirm each charge in the text thread before anything is charged.',
      },
      {
        q: 'How do I stop texts?',
        a: 'Reply STOP to opt out of non-essential messages. Reply HELP for support, or email hi@baristabot.app. Message and data rates may apply.',
      },
    ],
  },
  {
    id: 'shops',
    title: 'For coffee shops',
    items: [
      {
        q: 'How do coffee shops get started?',
        a: 'Beta is open for shops on Square POS. Email sam@beginthework.com or book a demo in Oklahoma City. We walk through menu import, the ordering flow, and emoji shortcuts.',
      },
      {
        q: 'Does it work with Square?',
        a: 'Yes. Barista Bot integrates with Square POS and Order Ahead. Orders look and act like a mobile order, so baristas keep their existing workflow.',
      },
      {
        q: 'What is Menu-Ops?',
        a: 'Menu-Ops is the menu source of truth from Espresso + Milk. When a shop is not on Square, Menu-Ops holds the menu, Stripe takes payment, and a HUD runs the ticket. Sister brand page: https://espressoplusmilk.com/brands/menu-ops',
      },
      {
        q: 'What are Drops?',
        a: 'Drops let a shop text a photo and tasting notes for a new coffee. The customer replies yes, and Barista Bot charges the card on file. No promo codes or links. Drops are coming soon.',
      },
    ],
  },
  {
    id: 'company',
    title: 'Company',
    items: [
      {
        q: 'Who makes Barista Bot?',
        a: 'Barista Bot is a product of Espresso + Milk, LLC, alongside Menu-Ops and ALL CAPS. Brand page: https://espressoplusmilk.com/brands/barista-bot',
      },
      {
        q: 'Where can I see it in person?',
        a: 'Book a demo at the studio: 219 NW 12th St, Suite 23, Oklahoma City, OK 73103. ALL CAPS. is the hospitality shop that puts Barista Bot and Menu-Ops to work in a real cup.',
      },
      {
        q: 'Where are the privacy policy and terms?',
        a: 'This site’s product policy is at /privacy-policy and terms at /terms-of-use. Company-wide legal lives at espressoplusmilk.com/privacy and espressoplusmilk.com/terms.',
      },
    ],
  },
];

export const FAQ_ITEMS = FAQ_SECTIONS.flatMap((section) => section.items);

export function faqPageJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'FAQPage',
        '@id': SCHEMA_IDS.faqPage,
        url: `${SITE_ORIGIN}/faq`,
        name: 'Barista Bot FAQs',
        description:
          'Text ordering for coffee shops: how to order, Square POS, emoji shortcuts, and Espresso + Milk.',
        isPartOf: { '@id': SCHEMA_IDS.website },
        about: { '@id': SCHEMA_IDS.organization },
        publisher: { '@id': SCHEMA_IDS.organization },
        mainEntity: FAQ_ITEMS.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.a,
          },
        })),
      },
      {
        '@type': 'WebPage',
        '@id': SCHEMA_IDS.faqWebPage,
        url: `${SITE_ORIGIN}/faq`,
        name: 'FAQs — Barista Bot',
        description:
          'Frequently asked questions about Barista Bot text ordering, Square, and Espresso + Milk.',
        isPartOf: { '@id': SCHEMA_IDS.website },
        publisher: { '@id': SCHEMA_IDS.organization },
        about: { '@id': SCHEMA_IDS.app },
        mainEntity: { '@id': SCHEMA_IDS.faqPage },
        breadcrumb: { '@id': `${SITE_ORIGIN}/faq#breadcrumb` },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `${SITE_ORIGIN}/faq#breadcrumb`,
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: `${SITE_ORIGIN}/`,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'FAQs',
            item: `${SITE_ORIGIN}/faq`,
          },
        ],
      },
    ],
  };
}
